import React  from 'react';
import {GraphView} from './graph-view';
import {CompletedItemGenericView} from '../generic-view';

export const CompletedItemGraphView = () => {
    return <CompletedItemGenericView innerView={GraphView}/>
}